export default __webpack_public_path__ + "static/media/grid1.42784051.png";